export default "__VITE_ASSET__5172c892__"